import { preview } from '@/components/form/preview'

import { CompanyEmail } from './CompanyEmail'
import { CompanyPhone } from './CompanyPhone'
import { Pods } from './Pods'

import { useTexts } from '../../hooks/useTexts'

import type { TrackingAppViewProps as Props } from '../../types'

export function Content(props: Props) {
  const { formValues } = props

  const texts = useTexts()

  return (
    <>
      <preview.SectionTitle variant="alternative">{texts.companyInformation}</preview.SectionTitle>

      <preview.Field testId="trackingPage-companyName" label={texts.companyName}>
        {formValues.companyName || '-'}
      </preview.Field>

      <preview.Field testId="trackingPage-companySlogan" label={texts.companySlogan}>
        {formValues.companySlogan || '-'}
      </preview.Field>

      <CompanyPhone
        companyPhone={formValues.companyPhone || '-'}
        showContactPhone={formValues.showContactPhone && !!formValues.companyPhone}
      />

      <CompanyEmail
        companyEmail={formValues.companyEmail || '-'}
        showContactEmail={formValues.showContactEmail && !!formValues.companyEmail}
        useCompanyEmailAsReplyTo={formValues.useCompanyEmailAsReplyTo && !!formValues.companyEmail}
      />

      <preview.Divider />

      <preview.Field testId="trackingPage-showEtaRange" label={texts.showEtaRange}>
        {texts.onOff(formValues.showEtaRange)}
      </preview.Field>

      <preview.Divider />

      <Pods
        showAudioPod={formValues.showAudioPod}
        showPicturePod={formValues.showPicturePod}
        showNotePod={formValues.showNotePod}
        showSignaturePod={formValues.showSignaturePod}
      />
    </>
  )
}
